export const REGRA_SENHA_FORTE =
  'Mínimo de 8 caracteres, com letra maiúscula, minúscula, número e caractere especial.';

export function mensagemSenhaFraca(senha) {
  if (!senha || senha.length < 8) {
    return 'A senha deve ter no mínimo 8 caracteres';
  }

  if (!/[a-z]/.test(senha)) {
    return 'A senha deve ter letra minúscula';
  }

  if (!/[A-Z]/.test(senha)) {
    return 'A senha deve ter letra maiúscula';
  }

  if (!/\d/.test(senha)) {
    return 'A senha deve ter número';
  }

  if (!/[^A-Za-z0-9]/.test(senha)) {
    return 'A senha deve ter caractere especial';
  }

  return null;
}
